export const AA_DYNAMIC_AGREEMENT_COPY = 'aa_dynamic_agreement_copy';
export const AA_PAYPAL = 'aa_paypal';
export const AA_PURCHASE_REVIEW_SCREEN = 'aa_purchase_review_screen';
export const PRICE_WITH_ASTERISK = 'PRICE_WITH_ASTERISK';
export const SHOW_PICKER = 'show_picker';
export const TOKEN_EXPIRED =
    'Unable to validate token reason: Token is not valid';
export const AGE_GATE = 'age_gate_enabled';